import React from 'react';
import {noop} from 'lodash';

import CancelledPremierOn from '/component/partial/report/CancelledPremierOn';
import {FrontlineClientRole} from '/component/partial/report/FrontlineClientRole';
import {PeopleRole} from '/component/partial/report/PeopleRole';
import PersonFullName from '/component/partial/report/PersonFullName';
import {PREMIER_CANCELLATIONS} from '/enum/peopleToContact.enum';
import {
  REPORT_CLIENT_TO_CONTACT,
  REPORT_CLIENT_TO_CONTACT_PREMIER_CANCELATION,
} from '/enum/records.enum';
import {FILTER_TYPES} from '/enum/tealium.enum';

import {generateOnRecordPress} from '../PeopleToContact.util';
import {PeopleToContactDataProvider} from '../PeopleToContactDataProvider';

import {useRecordsSorting} from '/context/RecordsSort/useRecordsSorting';

interface FeatureFlag {
  CC_SR: boolean;
}

interface PremierCancelationProps {
  featureFlag: FeatureFlag;
  onItemPress: (item: {
    value: number;
    recordsName: string;
    filterName: string;
  }) => void;
  onShowProfile: () => void;
  parentScreenName: string;
  showFullReport: boolean;
  reportParams: any;
}

export const PremierCancelation: React.FC<PremierCancelationProps> = ({
  onItemPress = noop,
  onShowProfile = noop,
  parentScreenName = '',
  showFullReport = false,
  reportParams = null,
  featureFlag = {
    CC_SR: false,
  },
}) => {
  const {sortParam} = useRecordsSorting({
    recordsName: REPORT_CLIENT_TO_CONTACT_PREMIER_CANCELATION,
  });

  const onViewMore = () => {
    onItemPress({
      value: 0,
      recordsName: REPORT_CLIENT_TO_CONTACT,
      filterName: REPORT_CLIENT_TO_CONTACT_PREMIER_CANCELATION,
    });
  };

  // if the context has not been initialized yet, we take sorting from
  // the parent (default sorting)
  const defaultSorting = sortParam?.params
    ? [{...sortParam?.params}]
    : reportParams;
  return (
    <PeopleToContactDataProvider
      screenParams={{type: PREMIER_CANCELLATIONS}}
      clientMilestone={FILTER_TYPES.premierCancellation}
      onViewMore={onViewMore}
      reportParams={defaultSorting}
      reportName={REPORT_CLIENT_TO_CONTACT_PREMIER_CANCELATION}
      parentScreenName={parentScreenName}
      dataRendererProps={{
        personNameComponent: PersonFullName,
        personRoleComponent: featureFlag.CC_SR
          ? PeopleRole
          : FrontlineClientRole,
        personInfoComponent: CancelledPremierOn,
        onRecordPress: generateOnRecordPress({
          onShowProfile,
        }),
        showFullReport,
      }}
    />
  );
};
